import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

/**
 * Resolves an old WordPress upload path to a download URL, so links shared
 * before the new site went live keep working.
 */
@Injectable({ providedIn: 'root' })
export class LegacyFilesService extends HttpServiceBase {
    protected override baseUrl = '/legacy-files';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    /** `path` is the original URL path, e.g. /wp-content/uploads/2019/10/Manual.pdf */
    public resolve(path: string): Observable<any> {
        return this._http.get(`${this.baseUrl}/resolve`, { params: { path } })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
